import { Card } from 'govbr.frontend.policy/components';
import PropTypes from 'prop-types';

const ServiceCard = ({ service, isEditMode }) => {
  const { url, categoria, titulo, descricao } = service;

  const title = titulo || service.title || '';
  const description = descricao || service.descricao || '';

  const cardItem = {
    '@id': url,
    remoteUrl: url,
    title,
    titulo_card: title,
    subtitle: categoria || '',
    description,
    descricao_card: description,
  };

  return (
    <Card
      item={cardItem}
      size="md"
      background="gray"
      hideIcons
      hideDescription={false}
      columns="3"
      isEditMode={isEditMode}
      serviceCard
    />
  );
};

ServiceCard.propTypes = {
  service: PropTypes.shape({
    url: PropTypes.string.isRequired,
    categoria: PropTypes.string,
    titulo: PropTypes.string,
    title: PropTypes.string,
    descricao: PropTypes.string,
    description: PropTypes.string,
  }).isRequired,
  isEditMode: PropTypes.bool,
};

export default ServiceCard;
